import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const styles = () => {
  return {
    width: "100%",
    "& .MuiDataGrid-root": {
      fontSize: "13px",
      borderRadius: 0,
      marginBottom: "12px",
    },
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#E9ECF5",
      borderBottom: "1px solid #D6DDEA",
      borderRadius: 0,
      "& .MuiDataGrid-withBorderColor": {
        borderColor: "#D6DDEA",
      },
    },
    "& .MuiDataGrid-columnHeader:focus": {
      outline: "unset !important",
    },
    "& .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "white",
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "white",
      minHeight: "40px",
      "& .MuiDataGrid-selectedRowCount": {
        visibility: "hidden",
      },
    },
    "& .MuiTablePagination-toolbar": {
      minHeight: "40px",
      "& p": {
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
    "& .MuiDataGrid-virtualScroller": {
      // overflowY: "scroll !important",
      // maxHeight: "calc(100vh - 360px)",
    },
  };
};

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const DataTable = ({
  rows = [],
  columns = [],
  loading = false,
  onRowClick = () => {},
  hideFooter = false,
  paginationMode = "client",
  pageSizeOptions = PAGE_SIZE_OPTIONS,
  paginationModel = {},
  setPaginationModel = undefined,
  totalCount = 0,
  rowHeight = 40,
  columnHeaderHeight = 40,
  getRowClassName = () => {},
  sortingMode = "client",
  sortModel = {},
  setSortModel = undefined,
  disableColumnSelector = true,
  disableColumnFilter = true,
  showColumnVerticalBorder = true,
}) => {
  const getPaginations = () => {
    if (paginationMode === "server") {
      return {
        paginationModel: paginationModel,
        onPaginationModelChange: setPaginationModel,
        paginationMode: paginationMode,
        rowCount: totalCount,
      };
    }
  };

  const getSort = () => {
    if (sortingMode === "server") {
      return {
        sortingMode: sortingMode,
        sortModel: sortModel,
        onSortModelChange: setSortModel,
        sortingOrder: ["asc", "desc"],
      };
    }
  };

  return (
    <Box className="data-table" sx={styles}>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight={true}
        loading={loading}
        rowHeight={rowHeight}
        columnHeaderHeight={columnHeaderHeight}
        disableColumnSelector={disableColumnSelector}
        disableColumnFilter={disableColumnFilter}
        showColumnVerticalBorder={showColumnVerticalBorder}
        onRowClick={onRowClick}
        hideFooter={hideFooter}
        getRowClassName={getRowClassName}
        pageSizeOptions={pageSizeOptions}
        {...getPaginations()}
        {...getSort()}
      />
    </Box>
  );
};

export default DataTable;
